module.exports = __webpack_public_path__ + "img/marcelas.d6cba14c.png";